import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-70e3d24c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "side-selector"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("归属机构");

const _hoisted_3 = {
  class: "subject-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "popover-category"
};
const _hoisted_7 = {
  class: "category-title"
};
const _hoisted_8 = {
  key: 0,
  class: "count"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode("案例分类");

const _hoisted_10 = {
  class: "subject-list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  class: "popover-category"
};
const _hoisted_14 = {
  class: "category-title"
};
const _hoisted_15 = {
  key: 0,
  class: "count"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode("归属学期");

const _hoisted_17 = {
  class: "subject-list"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: "popover-category"
};
const _hoisted_21 = {
  class: "category-title"
};
const _hoisted_22 = {
  key: 0,
  class: "count"
};
import { SelectType } from './types';
import useSelector from '../hooks/useSelector';
export default /*#__PURE__*/_defineComponent({
  props: {
    info: {
      type: Object,
      default: () => null
    }
  },
  emits: ["updateSelector"],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const settingInfo = inject('settingInfo');
    const filterList = ref([]);
    watch(settingInfo, val => {
      if (val) {
        filterList.value = val.filter_param.split(',');
      }
    });
    const selectInfo = reactive({
      organ_id: '',
      semester_id: '',
      classify_id: '',
      schoolyear_id: ''
    });
    const [organList, isShowMoreOrgan, organChange] = useSelector(item => {
      selectInfo.organ_id = item.id;
      emit('updateSelector', selectInfo);
    });
    const [classifyList, isShowMoreClassify, classifyChange] = useSelector(item => {
      selectInfo.classify_id = item.id;
      emit('updateSelector', selectInfo);
    });
    const [termList, isShowMoreTerm, termChange] = useSelector(item => {
      selectInfo.semester_id = item.id;
      selectInfo.schoolyear_id = item.pid;
      emit('updateSelector', selectInfo);
    });

    const toSting = id => {
      if (typeof id === 'string') return id;else return '';
    };

    watch(() => props.info, val => {
      if (val) {
        organList.value = val.organList;
        classifyList.value = val.classifyList;
        termList.value = val.termList;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_popover = _resolveComponent("el-popover");

      const _component_el_menu_item = _resolveComponent("el-menu-item");

      const _component_el_sub_menu = _resolveComponent("el-sub-menu");

      const _component_el_menu = _resolveComponent("el-menu");

      return __props.info ? (_openBlock(), _createElementBlock("div", _hoisted_1, [filterList.value.includes(_unref(SelectType).ORGAN) ? (_openBlock(), _createBlock(_component_el_menu, {
        key: 0,
        "default-active": _unref(selectInfo).organ_id,
        "default-openeds": [_unref(SelectType).ORGAN]
      }, {
        default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
          index: _unref(SelectType).ORGAN
        }, {
          title: _withCtx(() => [_hoisted_2]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organList), (item, index) => {
            return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
              class: _normalizeClass(["category-item", _unref(selectInfo).organ_id == toSting(item.id) ? 'active-tag' : '']),
              index: toSting(item.id) + '',
              key: toSting(item.id),
              onClick: $event => _unref(organChange)({ ...item,
                id: toSting(item.id)
              })
            }, {
              default: _withCtx(() => [_createVNode(_component_el_popover, {
                placement: "right",
                offset: 20,
                width: 400,
                trigger: "hover",
                "show-arrow": false,
                disabled: item.childs && item.childs.length ? false : true
              }, {
                reference: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1), item.count ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(" + _toDisplayString(item.count) + ")", 1)) : _createCommentVNode("", true)])]),
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childs, subject => {
                  return _openBlock(), _createElementBlock("span", {
                    class: "subject-item",
                    key: subject.id,
                    onClick: $event => _unref(organChange)(subject)
                  }, [_createTextVNode(_toDisplayString(subject.name) + " ", 1), subject.count ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(subject.count) + ")", 1)) : _createCommentVNode("", true)], 8, _hoisted_4);
                }), 128))])]),
                _: 2
              }, 1032, ["disabled"])]),
              _: 2
            }, 1032, ["class", "index", "onClick"])), [[_vShow, _unref(isShowMoreOrgan) || index < 6]]);
          }), 128)), _unref(organList).length > 6 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "category-btn",
            onClick: _cache[0] || (_cache[0] = $event => isShowMoreOrgan.value = !_unref(isShowMoreOrgan))
          }, _toDisplayString(_unref(isShowMoreOrgan) ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["index"])]),
        _: 1
      }, 8, ["default-active", "default-openeds"])) : _createCommentVNode("", true), filterList.value.includes(_unref(SelectType).CLASSIFY) ? (_openBlock(), _createBlock(_component_el_menu, {
        key: 1,
        "default-active": _unref(selectInfo).classify_id,
        "default-openeds": [_unref(SelectType).CLASSIFY]
      }, {
        default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
          index: _unref(SelectType).CLASSIFY
        }, {
          title: _withCtx(() => [_hoisted_9]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classifyList), (item, index) => {
            return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
              class: _normalizeClass(["category-item", _unref(selectInfo).classify_id == toSting(item.id) + '' ? 'active-tag' : '']),
              index: toSting(item.id) + '',
              key: toSting(item.id),
              onClick: $event => _unref(classifyChange)({ ...item,
                id: toSting(item.id)
              })
            }, {
              default: _withCtx(() => [_createVNode(_component_el_popover, {
                placement: "right",
                offset: 20,
                width: 400,
                trigger: "hover",
                "show-arrow": false,
                disabled: item.childs && item.childs.length ? false : true
              }, {
                reference: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1), item.count ? (_openBlock(), _createElementBlock("span", _hoisted_15, "(" + _toDisplayString(item.count) + ")", 1)) : _createCommentVNode("", true)])]),
                default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childs, subject => {
                  return _openBlock(), _createElementBlock("span", {
                    class: "subject-item",
                    key: subject.id,
                    onClick: $event => _unref(classifyChange)(subject)
                  }, [_createTextVNode(_toDisplayString(subject.name) + " ", 1), subject.count ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(subject.count) + ")", 1)) : _createCommentVNode("", true)], 8, _hoisted_11);
                }), 128))])]),
                _: 2
              }, 1032, ["disabled"])]),
              _: 2
            }, 1032, ["class", "index", "onClick"])), [[_vShow, _unref(isShowMoreClassify) || index < 6]]);
          }), 128)), _unref(organList).length > 6 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "category-btn",
            onClick: _cache[1] || (_cache[1] = $event => isShowMoreClassify.value = !_unref(isShowMoreClassify))
          }, _toDisplayString(_unref(isShowMoreClassify) ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["index"])]),
        _: 1
      }, 8, ["default-active", "default-openeds"])) : _createCommentVNode("", true), filterList.value.includes(_unref(SelectType).SEMESTER) ? (_openBlock(), _createBlock(_component_el_menu, {
        key: 2,
        "default-active": _unref(selectInfo).semester_id,
        "default-openeds": [_unref(SelectType).SEMESTER]
      }, {
        default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
          index: _unref(SelectType).SEMESTER
        }, {
          title: _withCtx(() => [_hoisted_16]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(termList), (item, index) => {
            return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
              class: _normalizeClass(["category-item", _unref(selectInfo).schoolyear_id == toSting(item.pid) ? 'active-tag' : '']),
              index: toSting(item.pid) + '',
              key: toSting(item.pid),
              onClick: $event => _unref(termChange)({ ...item,
                id: toSting(item.id),
                pid: toSting(item.pid)
              })
            }, {
              default: _withCtx(() => [_createVNode(_component_el_popover, {
                placement: "right",
                offset: 20,
                width: 400,
                trigger: "hover",
                "show-arrow": false,
                disabled: item.childs && item.childs.length ? false : true
              }, {
                reference: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(item.name), 1), item.count ? (_openBlock(), _createElementBlock("span", _hoisted_22, "(" + _toDisplayString(item.count) + ")", 1)) : _createCommentVNode("", true)])]),
                default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childs, subject => {
                  return _openBlock(), _createElementBlock("span", {
                    class: "subject-item",
                    key: subject.pid,
                    onClick: $event => _unref(termChange)(subject)
                  }, [_createTextVNode(_toDisplayString(subject.name) + " ", 1), subject.count ? (_openBlock(), _createElementBlock("span", _hoisted_19, "(" + _toDisplayString(subject.count) + ")", 1)) : _createCommentVNode("", true)], 8, _hoisted_18);
                }), 128))])]),
                _: 2
              }, 1032, ["disabled"])]),
              _: 2
            }, 1032, ["class", "index", "onClick"])), [[_vShow, _unref(isShowMoreOrgan) || index < 6]]);
          }), 128)), _unref(termList).length > 6 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "category-btn",
            onClick: _cache[2] || (_cache[2] = $event => isShowMoreTerm.value = !_unref(isShowMoreTerm))
          }, _toDisplayString(_unref(isShowMoreTerm) ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["index"])]),
        _: 1
      }, 8, ["default-active", "default-openeds"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

});